module.exports = __webpack_public_path__ + "img/52.21a20728.gif";